import { 
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline, 
	AppTabs,
	Create,
	Edit,
	Crud,
	Show,
	trans
} from '@/router/index'

import SettingsSMTP from '@/components/modules/settings/SettingsSMTP'
import MailUp from '@/components/modules/settings/Integrations/MailUp'
import Tempest from '@/components/modules/settings/Integrations/Tempest'
import Aisa from '@/components/modules/settings/Integrations/Aisa'
import Wic from '@/components/modules/settings/Integrations/Wic'
import SettingsPrint from '@/components/modules/settings/SettingsPrint'
import SettingsOther from '@/components/modules/settings/SettingsOther'
import SettingsViewing from '@/components/modules/settings/SettingsViewing'
import SettingsOptions from '@/components/modules/settings/SettingsOptions'
import Automation from '@/components/modules/settings/automation/Automation'
import AutomationWizard from '@/components/modules/settings/automation/AutomationWizard'
// import Prestashop from '@/components/modules/settings/Integrations/Prestashop'
// import WooCommerce from '@/components/modules/settings/Integrations/WooCommerce'
import Shopify from '@/components/modules/settings/Integrations/Shopify'
import EnableIntegration from '@/components/modules/settings/Integrations/EnableIntegration'
import SettingsIntegrations from '@/components/modules/settings/SettingsIntegrations'
import SettingsIntegrationsApps from '@/components/modules/settings/SettingsIntegrationsApps'
import Logs from '@/components/modules/settings/Logs'
import SettingsPortal from '@/components/modules/settings/SettingsPortal'
import MefProductsTab from '@/components/modules/settings/MEFProductsTab'
import MEFSettings from '@/components/modules/settings/MEFSettings'
import SettingsStorage from '@/components/modules/settings/SettingsStorage'
import SettingsMobile from '@/components/modules/settings/SettingsMobile'


export const settings = [
	{
		path: '/settings',
		redirect: '/settingsgeneral'
	},
	{
		path: '/yellologs',
		redirect: '/logs'
	},
	{
		// Configuratore dell'app (Impostazioni → Mobile): voce del menu solo se il
		// cliente ha l'app attiva (App.vue, isMobileEnabled)
		path: '/settingsmobile',
		name: 'settingsmobile',
		beforeEnter: ifAuthenticatedOnline,
		component: SettingsMobile,
	},
	{ 
		path: '/settingsgeneral/',
		name: 'settingsgeneral',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsgeneral/',
					text: 'Generali',
				},
				{
					to: '/settingsgeneral/settingssmtp/',
					text: 'SMTP',
				},	
				{
					to: '/settingsgeneral/integrations',
					text: 'Integrazioni',
				},
				{
					to: '/settingsgeneral/viewing',
					text: 'Visualizzazione',
				},
				{
					to: '/settingsgeneral/print',
					text: 'Stampa',
				},
				{
					to: '/settingsgeneral/automations',
					text: 'Automazioni',
				},
				{
					to: '/settingsgeneral/portal',
					text: 'Area Clienti',
					module: 'portal',
				},
				{
					to: '/settingsgeneral/storage',
					text: 'Spazio disco',
				},
				{
					to: '/settingsgeneral/other',
					text: 'Altro',
				}
			],
		},	
		children: [
			{
				path: '/settingsgeneral/',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsOptions,
			},
			{
				path: '/settingsgeneral/settingssmtp/',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsSMTP,
			},			
			{
				path: '/settingsgeneral/integrations',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsIntegrations,
			},		
			{
				path: '/settingsgeneral/integrations/others',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsIntegrationsApps,
			},
			{
				path: '/settingsgeneral/viewing',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsViewing,
			},
			{
				path: '/settingsgeneral/print',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsPrint,
			},
			{
				path: '/settingsgeneral/automations',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'automations'
				},
				props: {
					modelDef: 'automations',
					actionIcon: 'mdi-sitemap-outline',
					title: 'automations',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/settingsgeneral/portal',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsPortal,
			},
			{
				path: '/settingsgeneral/storage',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsStorage,
			},
			{
				path: '/settingsgeneral/other',
				beforeEnter: ifAuthenticatedOnline,
				component: SettingsOther,
			},
		],
	},


	// GENERAL TYPES
	{
		path: '/generaltypes/create',
		name: 'generaltypes-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'generaltypes',
			urlAppend: route.params.urlAppend,
			redirect: {back: -1}
		}),
	},
	{ 
		path: '/generaltypes/:id',
		name: 'generaltypes',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'generaltypes',
			id:  parseInt(route.params.id),
			urlAppend: route.params.urlAppend,
			redirect: {back: -1}
		}), 
	},

	// YELLO LOG
	{ 
		path: '/logs/',
		name: 'yellologs',
		beforeEnter: ifAuthenticatedOnline,
		component: Logs,
	},
	{ 
		path: '/logs/',
		name: 'yellologs-show',
		beforeEnter: ifAuthenticatedOnline,
		component: Logs,
	},

	// INTEGRATIONS
	{ 
		path: '/settingsgeneral/integrations/woocommerce/:id',
		name: 'woocommerce',
		beforeEnter: ifAuthenticatedOnline,
		component: EnableIntegration,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{ 
		path: '/settingsgeneral/integrations/mailup/:id',
		name: 'mailup',
		beforeEnter: ifAuthenticatedOnline,
		component: MailUp,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{ 
		path: '/settingsgeneral/integrations/tempest/:id',
		name: 'Tempest',
		beforeEnter: ifAuthenticatedOnline,
		component: Tempest,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{
		path: '/settingsgeneral/integrations/aisa/:id',
		name: 'aisa',
		beforeEnter: ifAuthenticatedOnline,
		component: Aisa,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{
		path: '/settingsgeneral/integrations/wic/:id',
		name: 'wic',
		beforeEnter: ifAuthenticatedOnline,
		component: Wic,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{
		path: '/settingsgeneral/integrations/mef/:id',
		name: 'mef',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/settingsgeneral/integrations/mef/' + route.params.id,
					text: 'Generali',
				},
				{
					to: '/settingsgeneral/integrations/mef/' + route.params.id + '/pricelists',
					text: 'Listini Prodotti',
				},
			],
		}),
		children: [
			{
				path: '/settingsgeneral/integrations/mef/:id/',
				beforeEnter: ifAuthenticatedOnline,
				component: MEFSettings,
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
			{
				path: '/settingsgeneral/integrations/mef/:id/pricelists',
				beforeEnter: ifAuthenticatedOnline,
				component: MefProductsTab,
			},
		],
	},
	{
		path: '/settingsgeneral/integrations/prestashop/:id',
		name: 'prestashop',
		beforeEnter: ifAuthenticatedOnline,
		component: EnableIntegration,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{
		path: '/settingsgeneral/integrations/shopify/:id',
		name: 'shopify',
		beforeEnter: ifAuthenticatedOnline,
		component: Shopify,
		props: (route) => ({
			id:  parseInt(route.params.id),
			redirect: {back:-1}
		}),
	},
	{
		path: '/integrationwebsites/create',
		name: 'integrationwebsites-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'integrationwebsites',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: {back: -1}
		}),
	},
	{ 
		path: '/integrationwebsites/:id/edit',
		name: 'integrationwebsites-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'integrationwebsites',
			id: parseInt(route.params.id),
			redirect: {back: -1}
		}),
	},	
	{
		path: '/automations/create',
		name: 'automations-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: AutomationWizard,
	},
	{
		path: '/automations/:id/edit',
		name: 'automations-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: AutomationWizard,
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/automations/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/automations/' + parseInt(route.params.id) + '/',
					text: 'Automazione',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'automations-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Automation,
				meta: {
					title: 'Automazione'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
		]
	},
]